import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  viewChild,
} from '@angular/core';

import { toObservable } from '@angular/core/rxjs-interop';

@Component({
  selector: 'ss-waf-component',
  standalone: true,
  imports: [],
  templateUrl: './waf.component.html',
  styleUrl: './waf.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WafComponent {
  private readonly wafOutlet =
    viewChild<ElementRef<HTMLDivElement>>('wafOutlet');
  readonly wafOutlet$ = toObservable(this.wafOutlet);
}
